import gql from 'graphql-tag';

export const PlicAlbumPhotosUpload = gql`
  mutation plicAlbumPhotosUpload($input: PlicAlbumPhotosUploadInput!) {
    plicAlbumPhotosUpload(input: $input) {
      success
    }
  }
`;

export const AlbumForPlicPendingPhotos = gql`
  query albumForPlicPendingPhotos($id: RecordID!) {
    album(id: $id) {
      id
      plic_pending_photo_uploads_count
    }
  }
`;

export const AccountForPlicPendingPhotos = gql`
  query accountForPlicPendingPhotos {
    me {
      id
      plic_pending_photo_uploads_count
    }
  }
`;
